import { render } from "./AgeRange.vue?vue&type=template&id=718e9f52"
import script from "./AgeRange.vue?vue&type=script&lang=js"
export * from "./AgeRange.vue?vue&type=script&lang=js"

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__